import { ReactNode } from 'react'
import { Button, Link } from '@mui/material'

import { LinkIcon } from 'src/assets/icons'

interface IProps {
  arweaveUrl: string | null
  text: string | ReactNode
  isDisabled?: boolean
}

export const NFTOutlinedButton = ({ arweaveUrl, text, isDisabled }: IProps) => {
  if (!arweaveUrl) {
    return null
  }

  return (
    <div>
      <Button
        disabled={!arweaveUrl || isDisabled}
        component={Link}
        target="_blank"
        href={arweaveUrl}
        variant="outlined"
        endIcon={<LinkIcon />}
      >
        {text}
      </Button>
    </div>
  )
}
